/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { UserAvatarFragmentDoc } from '../users/UserAvatar.generated.js';
export type CrmPersonAvatarAndTitleForm_CrmPersonFragment = { __typename: 'CrmPerson', id: string, title: Types.Salutation, firstname: string, familyname: string, crmCompany: { __typename: 'CrmCompany', id: string, title: string }, avatar?: { __typename: 'AttachmentSnapshot', id: string, url: string } | null };

export const CrmPersonAvatarAndTitleForm_CrmPersonFragmentDoc = gql`
    fragment CrmPersonAvatarAndTitleForm_CrmPerson on CrmPerson {
  id
  title
  firstname
  familyname
  crmCompany {
    id
    title
  }
  ...UserAvatar
}
    ${UserAvatarFragmentDoc}`;